import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { Children, isValidElement, useContext, useMemo, } from "react";
import { prefixClassname } from "../styles/index.js";
import NumberKeyboardButton from "./number-keyboard-button.js";
import NumberKeyboardContext from "./number-keyboard.context.js";
function useNumberKeyboardHeaderChildren(children) {
    const { title } = useContext(NumberKeyboardContext);
    return useMemo(() => {
        const __children__ = {
            title: title && (React.createElement(View, { className: prefixClassname("number-keyboard__title"), children: title })),
        };
        Children.forEach(children, (child) => {
            if (isValidElement(child)) {
                const element = child;
                const elementType = element.type;
                if (elementType === NumberKeyboardButton) {
                    const { type } = element.props;
                    if (type === undefined || type === "hide") {
                        __children__.right = element;
                    }
                }
            }
        });
        return __children__;
    }, [children, title]);
}
function NumberKeyboardHeader(props) {
    const { className, children: childrenProp, ...restProps } = props;
    const { left, title, right } = useNumberKeyboardHeaderChildren(childrenProp);
    return (React.createElement(View, { className: classNames(prefixClassname("number-keyboard__header"), className), ...restProps },
        left,
        title,
        right));
}
export default NumberKeyboardHeader;
